import { LocaleSeparators } from '../types/LocaleSeparators'
import { convertToNumber } from './liberalParseToNumber/convertToNumber'
import { extractSeparators } from './liberalParseToNumber/extractSeparators'
import { resolveSeparators } from './liberalParseToNumber/resolveSeparators'
import { sanitizeNumberStringWithSeparators } from './liberalParseToNumber/sanitizeNumberStringWithSeparators'

export const liberalParseToNumber = (input: string, localeSeparators?: LocaleSeparators): number => {
  if (!input || typeof input !== 'string') {
    return 0
  }

  const normalizedInput = input.normalize('NFKC').trim()

  // fast path for raw numbers
  if (/^-?\d+$/.test(normalizedInput)) {
    return parseInt(normalizedInput, 10)
  }

  const { separatorCounts, separatorPositions } = extractSeparators(normalizedInput)
  const resolvedSeparators = resolveSeparators(normalizedInput, separatorCounts, separatorPositions, localeSeparators)
  const sanitizedInput = sanitizeNumberStringWithSeparators(normalizedInput, resolvedSeparators, separatorCounts)

  return convertToNumber(sanitizedInput, resolvedSeparators)
}
